import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { IHomework, THomeworkFile } from '.';

type TGetHomeworkSubmissions = {
  student: string;
  section: string;
};

export type TAdminCreateHomeworkSubmission = {
  section: string;
  student: string;
  description: string;
  link?: string;
  files?: Array<THomeworkFile>;
};

export type TAdminUpdateHomeworkSubmission = {
  _id: string;
  description: string;
  link?: string;
  files?: Array<THomeworkFile>;
};

const apiDataProvider = new APIDataProvider();

export const getHomeworkSubmissionsAsAdmin = createAsyncThunk(
  '/admin/homeworks/get',
  async ({ section, student }: TGetHomeworkSubmissions) => {
    const path = `${AdminApiPaths.homeworks}?section=${section}&student=${student}`;
    const response = await apiDataProvider.get<TApiResponse<Array<IHomework>>>(
      path
    );

    return response.data;
  }
);

export const createHomeworkSubmissionAsAdmin = createAsyncThunk(
  '/admin/homeworks/create',
  async (data: TAdminCreateHomeworkSubmission) => {
    const path = `${AdminApiPaths.homeworks}/submissions`;
    const response = await apiDataProvider.post<TApiResponse<IHomework>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateHomeworkSubmissionAsAdmin = createAsyncThunk(
  '/admin/homeworks/update',
  async ({ _id, ...data }: TAdminUpdateHomeworkSubmission) => {
    const path = `${AdminApiPaths.homeworks}/submissions/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<IHomework>>(
      path,
      data
    );

    return response.data;
  }
);

export const deleteHomeworkSubmissionAsAdmin = createAsyncThunk(
  '/admin/homeworks/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.homeworks}/submissions/${id}`;
    const response = await apiDataProvider.delete<TApiResponse<IHomework>>(
      path
    );

    return response.data;
  }
);
